import { List, Map } from "immutable"
import { get } from "../../../DeNieuweBibliotheek/custom_api/api"
import { media_image_parser } from "./parser"
import { MediaImage, ParsedMediaImage, ParsedMetatagComputedItem } from "./types"
import { objectMap } from "../../utils/object"
import { ApiResult } from "../apiTypes"
import { Activity } from "./drupalTypes"

declare global {
  interface Window {
    DrupalInternalUrl: string
    DrupalExternalUrl: string
  }
}

const drupalUrl = "/api/drupal";


export const processRichText: (html: string) => string = html =>
  html.replace("<ul>", '<ul class="richtext__bullet-list">').replace("<ol>", '<ol class="richtext__check-list">')

// Replace internal with external Urls (to avoid users from being unable to see images served by the internal URL)
export const fixMediaUrl = (style_url: string): string => {
  const internalUrl: string = window.DrupalInternalUrl
  const externalUrl: string = window.DrupalExternalUrl

  if (!externalUrl) return style_url
  if (style_url.startsWith('/')) return externalUrl + style_url
  if (style_url && internalUrl) return style_url.replace(internalUrl, externalUrl)

  return style_url
}

export const getImageStyles = async (imageIds: List<number>): Promise<ApiResult<ParsedMediaImage[]>> => {
  var rawImageStyles = await get<MediaImage[]>(`${drupalUrl}/api/image-styles/${imageIds.toSet().join('+')}`)
  if (rawImageStyles == 'error' || rawImageStyles == 'loading') return rawImageStyles
  var parsedImageStyles = rawImageStyles.map(media_image_parser).map(media => {
    if (media.field_media_image.image == undefined) return media
    const urls = media.field_media_image.image.style_urls
    media.field_media_image.image.style_urls = objectMap(urls, (value, _) => fixMediaUrl(value))
    return media
  })
  return parsedImageStyles
}

export const getDrupalActivities: (dbIds: List<number>) => Promise<ApiResult<Activity[]>> = async pdbIds => {
  var activities = await get<Activity[]>(`${drupalUrl}/api/activities/${pdbIds.join("+")}`)
  if (activities == 'error' || activities == 'loading') return activities
  var imageIds = List(activities.map(a => parseInt(a.image_id)))
  var imageStyles = await getImageStyles(imageIds)
  if (imageStyles == 'error' || imageStyles == 'loading') return activities

  // Create a map for faster lookup by mid
  const imageMap: Map<number, ParsedMediaImage> = Map(imageStyles.map(image => [image.id, image]))
  const mappedActivities = activities.map(a => {
    a.image = imageMap.get(parseInt(a.image_id)) as ParsedMediaImage
    return a
  })
  return mappedActivities
}

export const parseMetatagTitle = (metatag: List<ParsedMetatagComputedItem>): string => metatag
  .find(item => item.attributes?.name === 'title')?.attributes?.content;

export const parseFieldMetatags = (metatag: string, field: string, fallback?: string): string => {
  if (!metatag) return fallback || '';
  const parsed = JSON.parse(metatag);
  return parsed[field] || fallback || '';
};
